import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  tabs: {
    width: '256px',
    height: '44px',
    padding: '4px',
    alignItems: 'center',
    borderRadius: 30,
    boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  tab: {
    width: '120px',
    minHeight: '36px',
    borderRadius: 20,
    fontSize: 14,
    fontWeight: isKiteUser ? FONT_WEIGHT_REGULAR : FONT_WEIGHT_SEMIBOLD,
    textTransform: 'none',
    color: theme.palette.grey2,
    '&.Mui-selected': {
      backgroundColor: theme.palette.lightGrey,
      color: isKiteUser && theme.palette.primary2,
    },
    '&:first-child': {
      marginRight: '8px',
    },
    [theme.breakpoints.down('md')]: {
      width: 'calc(50% - 4px)',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: 'calc(50% - 4px)',
      }),
    },
  },
}));
